import { LoadingWolf, VStack } from '@rtkwlf/fenrir-react';
import { ScannerConnectionStatus } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useScannerDetails } from '@apis/rendall/queries/use-scanner-details/use-scanner-details';

import { scannerDetailSelect } from '../../../../hooks/use-enhanced-scanner-details/use-enhanced-scanner-details';
import { ScanExclusion } from '../scanners-config/components/scanner-configuration-tabs/tabs/scan-exclusion/scan-exclusion';
import { ScanExclusionReadOnly } from '../scanners-config/components/scanner-configuration-tabs/tabs/scan-exclusion/scan-exclusion-read-only';

const ScanExclusionPage: React.FC = () => {
  const { scannerId = '' } = useParams();
  const { t } = useTranslation('ui');

  const { data: scannerDetails, isPending } = useScannerDetails(scannerId, {
    select: scannerDetailSelect,
  });

  if (isPending || !scannerDetails) {
    return (
      <VStack width="full" xAlign="center" style={{ height: '60vh' }}>
        <LoadingWolf isLoading caption={t('loader.caption')} />
      </VStack>
    );
  }

  if (scannerDetails?.connectionStatus === ScannerConnectionStatus.Disconnected)
    return <ScanExclusionReadOnly />;

  return <ScanExclusion />;
};

export default ScanExclusionPage;

export const Component = () => <ScanExclusionPage />;
